export default (theme) => ({
  abstract__svg: {
    width: 500,
    height: 590,
  },
});
